import types  from "../types/types";

interface modelidconvocatoria {
  idConvocatoria: number;
}

const initialStateIdconvocatoria: modelidconvocatoria = {
  idConvocatoria: 0,
};

export const convocatoriasReducer = (state = initialStateIdconvocatoria, action: any) => {
  switch (action.type) {
    case types.idConvocatoria:
      return {
        ...state,
        idConvocatoria: action.payload.idConvocatoria,
      };
    default:
      return state;
  }
};

interface modeleditarconvocatoria {
  editarConvocatoria: boolean;
}

const initialStateEditarconvocatoria: modeleditarconvocatoria = {
  editarConvocatoria: false,
};

export const edicionReducer = (state = initialStateEditarconvocatoria, action: any) => {
  switch (action.type) {
    case types.edicion:
      return {
        ...state,
        editarConvocatoria: action.payload.editarConvocatoria,
      };
    default:
      return state;
  }
};

interface modelcambiarpestaña {
  cambiarPestaña: string;
}

const initialStateCambiarPestaña: modelcambiarpestaña = {
  cambiarPestaña: "1",
};

export const cambiarPestañaReducer = (state = initialStateCambiarPestaña, action: any) => {
  switch (action.type) {
    case types.cambiarPestaña:
      return {
        ...state,
        cambiarPestaña: action.payload.cambiarPestaña,
      };
    default:
      return state;
  }
};





